import { Link } from 'react-router';
import { Icon, type IconName } from './Icon';

/**
 * Shared "no data yet" panel. Every inventory page starts empty (the DB is built
 * from scratch by the scanners), so this turns a bare gray sentence into a
 * centered card with an icon, a title, a body, and a primary call-to-action —
 * usually "run the scan on the Scheduler page".
 */
export function EmptyState({
  icon = 'inbox',
  title,
  body,
  actionLabel,
  actionTo,
}: {
  icon?: IconName;
  title: string;
  body?: React.ReactNode;
  actionLabel?: string;
  actionTo?: string;
}) {
  return (
    <div className="empty-state" data-testid="empty-state">
      {/* 30px stroke icon in --faint: the old inbox emoji carried its own colour and
          ignored the theme entirely. */}
      <div className="empty-icon">
        <Icon name={icon} size={30} />
      </div>
      <div className="empty-title">{title}</div>
      {body && <div className="empty-body">{body}</div>}
      {actionLabel && actionTo && (
        <div className="empty-actions">
          <Link to={actionTo} className="btn-primary">
            {actionLabel}
          </Link>
        </div>
      )}
    </div>
  );
}
